import { createSelector } from "@reduxjs/toolkit";
import { omit } from "ramda";

import { UIState } from "../../../store/HOC/genericUI.slice";
import { RootState } from "../../../store/rootReducer";
import { generateAddress } from "../../../utilities/forms";

import { ComponentId, SectionId } from "./enums";
import { FormDataInputs } from "./vehicle.slice";

const selectRegistrationNumber = (store: RootState) => ({
  name: "Nr. rejestracyjny",
  value: store.ac.vehicle.data[ComponentId.VEHICLE_REGISTRATION_NUMBER],
});

const selectMileage = (store: RootState) => {
  const mileage = store.ac.vehicle.data[ComponentId.VEHICLE_MILEAGE];

  return {
    name: "Przebieg",
    value: mileage ? `${mileage} km` : null,
  };
};

const selectCity = (store: RootState) => ({
  name: "Miasto użytkowania",
  value: store.ac.vehicle.data[ComponentId.VEHICLE_CITY],
});

//JIRA LPPLWEBMOB-750
//GIELK - 22.01.2024 -  Pojazd jezdny = pojazd nie odcholowany, mapowanie odwrotne tzn. zmienna IsVehicleDrivable jest mapowana true=Nie a false=Tak
const selectVehicleDrivable = (
  store: RootState
): { name: string; value: string | string[] | null } => {
  const isVehicleDrivable =
    store.ac.vehicle.data[ComponentId.VEHICLE_DRIVEABLE];
  if (isVehicleDrivable == "true") {
    return {
      name: "Czy pojazd został odholowany?",
      value: isVehicleDrivable ? "Nie" : "Nie",
    };
  } else {
    return {
      name: "Czy pojazd został odholowany?",
      value: isVehicleDrivable ? "Tak" : "Tak",
    };
  }
};

const selectCountryRepair = (store: RootState) =>
  store.ac.vehicle.data[ComponentId.COUNTRY_REPAIR];

const selectProvinceRepair = (store: RootState) =>
  store.ac.vehicle.data[ComponentId.PROVINCE_REPAIR];

const selectCityRepair = (store: RootState) =>
  store.ac.vehicle.data[ComponentId.CITY_REPAIR];

const selectRepairPlace = createSelector(
  selectCountryRepair,
  selectProvinceRepair,
  selectCityRepair,
  (country, province, city) => ({
    name: "Preferowane miejsce naprawy",
    value: generateAddress({
      city: city,
      province: province,
      country: country || { value: "", label: "" },
    }),
  })
);

export const selectSummaryData = createSelector(
  selectRegistrationNumber,
  selectMileage,
  selectCity,
  selectVehicleDrivable,
  selectRepairPlace,
  (registrationNumber, mileage, city, repair) => [
    registrationNumber,
    mileage,
    city,
    repair,
  ]
);

export const selectFormData = (store: RootState): FormDataInputs =>
  store.ac.vehicle.data;

export const selectUIData = (store: RootState): UIState => store.ac.vehicle.ui;

export const selectFormDataWithoutRedirect = createSelector(
  selectFormData,
  (data) => omit(["redirect"], data)
);

export const selectVehicleDriveable = createSelector(
  selectFormData,
  (state) => state.vehicleDriveable
);
